import { render } from "./InspectionComparison.vue?vue&type=template&id=70c3326a"
import script from "./InspectionComparison.vue?vue&type=script&lang=js"
export * from "./InspectionComparison.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__